<template>
  <div>
    <div class="container">
      <div class="row width_full">
        <div class="col_12">
          <div class="customer_content">
            <div class="common_subtitle pb_20">
              <h3 class="mb_0">User Management</h3>
              <button class="btn btn_success" style="float: right" @click.prevent="addNewUser()">Add New User</button>
            </div>
            <div class="row">
              <div class="col_12">
                <table-component :columns="columns" :rows="users" :header="true" :centralized="true" :sortable="sortable" :pagination="pagination" :searchShowStatus="true" :perPageShowStatus="true" @queryEvent="queryEvent" @sorting="sorting" @pageChanged="pageChanged">
                  <template v-slot:status="{ row }">
                    <span class="color_blue" v-if="row.status == 1">Active</span>
                    <span class="color_blue" v-else>Inactive</span>
                  </template>
                  <template v-slot:action="{ row }">
                    <span class="btn btn_success cursor_pointer" @click.prevent="updateCustomer(row)">Edit</span>
                    <span class="ml_10 btn btn_danger cursor_pointer" @click.prevent="deleteRecord(row)" v-if="row.id != 1">Delete</span>
                    <span class="ml_10 btn btn_danger cursor_pointer disabled" v-else>Delete</span>
                  </template>
                </table-component>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal-component v-if="showModal" :modal-size="'custom_modal_800p'" :header-classes="'display_table white_bg no_border pa15 pb_0'" :content-classes="'pl_15 pr_15'" @closeModal="closeModal">

      <template #header>
        <span class="modal_header_title">{{ modalTitle }}</span>
      </template>
      <template #content>
        <div class="row">
          <div class="col_12">
            <div :class="['form-group', {'has_error': errorFor('first_name')}]">
              <label>First Name</label>
              <input type="text" class="form_global" placeholder="First Name" v-model="form.first_name">
              <template v-if="errors && errors.first_name">
                <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.first_name" :key="'error_status_'+errorIndex">{{error}}</small>
              </template>
            </div>
            <div :class="['form-group', {'has_error': errorFor('last_name')}]">
              <label>Last Name</label>
              <input type="text" class="form_global" placeholder="Last Name" v-model="form.last_name">
              <template v-if="errors && errors.last_name">
                <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.last_name" :key="'error_status_'+errorIndex">{{error}}</small>
              </template>
            </div>
            <div :class="['form-group', {'has_error': errorFor('email')}]">
              <label>Email</label>
              <input type="email" class="form_global" placeholder="Email" v-model="form.email">
              <template v-if="errors && errors.email">
                <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.email" :key="'error_status_'+errorIndex">{{error}}</small>
              </template>
            </div>
            <div v-if="!edit" :class="['form-group', {'has_error': errorFor('password')}]">
              <label>Password</label>
              <input type="password" class="form_global" placeholder="Password" v-model="form.password">
              <template v-if="errors && errors.password">
                <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.password" :key="'error_status_'+errorIndex">{{error}}</small>
              </template>
            </div>
            <div :class="['form-group', {'has_error': errorFor('status')}]">
              <label>Status</label>
              <select class="form_global" v-model="form.status">
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
            </div>

            <div class="col_12  mb_10">
              <span>Permission</span>
              <div :class="['form_inline width_full', {'has_error': errorFor('permissions')}]">
                <template v-if="errors && errors.permissions">
                  <small class="d_flex_start" v-for="(error, errorIndex) in errors.permissions" :key="'error_status_'+errorIndex">{{error}}</small>
                </template>
              </div>
            </div>
            <div class="col_12 mb_15">
              <div class="item_list_search_checkbox">
                <div class="custom_checkbox mr_20 width_200p" v-for="(permision, i) in form.permissions" :key="'key'+i">
                  <input type="checkbox" :id="'permission_'+permision.id" name="permission" :value="permision.module" v-model="permision.status">
                  <label :for="'permission_'+permision.id" style="text-transform: capitalize">{{permision.name}}</label>
                </div>
              </div>
            </div>

            <div class="d_flex_end">
              <button class="btn btn_common" @click="submit()">Save</button>
            </div>
          </div>
        </div>
      </template>
    </modal-component>
  </div>
</template>

<script>
import TableComponent from "../../components/shared/TableComponent";
import ModalComponent from "../../components/shared/ModalComponent";
export default {
  name: "Index",
  components: {
    TableComponent,
    ModalComponent
  },
  data() {
    return {
      modalTitle: 'Add User',
      users: [],
      allPermission: [],
      sort: '1',
      showModal: false,
      sortable: {
        order: 'id',
        sort: 'desc'
      },
      filter: {
        status: '',
        per_page: 10
      },
      columns: [
        {
          label: "Name",
          field: "name",
          sortable: true
        },
        {
          label: "Email",
          field: "email",
          sortable: true
        },
        {
          label: "Status",
          field: "status",
          sortable: false,
          slot: true,
        },
        {
          label: "Action",
          field: 'action',
          sortable: false,
          slot: true,
        }
      ],
      pagination: null,
      queryParams: {
        page: 1,
        per_page: 10,
        search: '',
        search_columns: 'name',
        sort: '',
        sort_order: '',
      },
      form: {
        email: '',
        status: 1,
        password: '',
        first_name: '',
        last_name: '',
        permissions: []
      },
      edit: false,
    }
  },
  created() {
    this.loadData()
    this.loadPermissions();
  },
  watch: {
    queryParams: {
      deep: true,
      handler() {
        this.loadData()
      }
    },
  },
  methods: {
    sorting({
              column,
              order
            }) {
      this.queryParams.sort = column;
      this.queryParams.sort_order = order;
    },
    pageChanged(page) {
      this.queryParams.page = page;
    },
    queryEvent(query) {
      this.queryParams.search = query.search
      this.queryParams.per_page = query.per_page
    },
    loadData() {
      this.axios.get('/users', {
        params: {
          ...this.queryParams
        }
      }).then((response) => {
        this.users = response.data.data;
        this.pagination = response.data.meta;
      })
    },
    deleteRecord(row) {
      this.$swal({
        title: 'Are you sure want to delete?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/users/' + row.id).then(() => {
            this.$swal.fire(
                'Deleted',
                'User has been deleted!',
                'success'
            )
            this.loadData();
          });
        }
      });
    },
    loadPermissions() {
      this.axios.get('get/permission').then((response) => {
        this.allPermission = response.data
        response.data.map((item) => {
          this.form.permissions.push({
            id: item.id,
            module: item.module,
            name: item.name,
            status: false,
          })
        })
      })
    },
    addNewUser() {
      this.edit = false
      this.showModal = true
      this.modalTitle = 'Add User'
    },
    closeModal() {
      this.showModal = false
      this.resetForm()
    },
    submit() {
      this.errors = null;
      this.loading = true;
      if(this.edit) {
        this.axios.patch('/users/'+this.form.id, this.form)
            .then(() => {
              this.$swal.fire(
                  'Success',
                  'User Stored Successfully!',
                  'success'
              )
              this.showModal = false
              this.resetForm()
              this.loadData();
              this.edit = false
            })
            .catch((err) => {
              this.errors = err.response.data.errors
            })
            .finally(() => {
              this.loading = false;
            })
      } else {
        this.axios.post('/users', this.form)
            .then(() => {
              this.$swal.fire(
                  'Success',
                  'User Stored Successfully!',
                  'success'
              )
              this.showModal = false
              this.resetForm()
              this.loadData();
              this.edit = false
            })
            .catch((err) => {
              this.errors = err.response.data.errors
            })
            .finally(() => {
              this.loading = false;
            })
      }
    },
    resetForm() {
      this.form = {
        email: '',
        status: 1,
        password: '',
        first_name: '',
        last_name: '',
        permissions: []
      }
      this.loadPermissions();
    },
    updateCustomer(row) {
      this.modalTitle = 'Edit User'
      this.edit = true
      this.showModal = true
      this.form = {...row}
      let permissions = []
      this.allPermission.map(item => {
        let object = {
          id: item.id,
          module: item.module,
          name: item.name,
          status: this.checkStatus(item.module),
        }
        permissions.push(object)
      });
      this.form.permissions = permissions
    },
    checkStatus(module){
      let permission = this.form.permissions.find((item) => item.module === module)
      if(permission)
        return true
      else
        return false
    },
  },
}
</script>
<style scoped>
.custom_checkbox {
  display: inline-block;
  position: relative;
}

.custom_checkbox [type="checkbox"] {
  position: absolute;
  left: -9999px;
}

.custom_checkbox label {
  position: relative;
  padding-left: 22px;
  cursor: pointer;
  margin-bottom: 0;
  line-height: 24px;
  padding-right: 15px;
  font-size: 14px;
}

.custom_checkbox [type="checkbox"]:checked+label:before,
.custom_checkbox [type="checkbox"]:not(:checked)+label:before {
  content: '';
  position: absolute;
  left: 0px;
  top: 1px;
  width: 16px;
  height: 16px;
  border: 1px solid #333;
  background: #fff;
  border-radius: 0px;
}

.custom_checkbox [type="checkbox"]:not(:checked)+label:after,
.custom_checkbox [type="checkbox"]:checked+label:after {
  content: "";
  position: absolute;
  top: 2px;
  left: 4.5px;
  width: 7px;
  height: 12px;
  background: #fff!important;
  border: 3px solid #3c74e7;
  border-top-width: 0;
  border-left-width: 0;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}

.custom_checkbox [type="checkbox"]:disabled+label:before{
  opacity: .5;
  border: 1px solid #999;
}
.custom_checkbox [type="checkbox"]:disabled+label:after{
  content: "";
  position: absolute;
  top: 2px;
  left: 4.5px;
  width: 7px;
  height: 12px;
  background: #fff!important;
  border: 3px solid transparent;
  border-top-width: 0;
  border-left-width: 0;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  cursor: not-allowed;
}

.custom_checkbox [type="checkbox"]:not(:checked)+label:after {
  opacity: 0;
}
.custom_checkbox [type="checkbox"]:disabled+label:after {
  opacity: .5;
}
</style>
